import * as React from "react";
import { AppBar, Box, Stack, Typography, IconButton } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useNavigate } from "react-router-dom";

const Header = ({
  title,
  subtitle,
  variant = "h5",
  withBackButton = false,
  disabled = false,
}) => {
  const navigate = useNavigate();
  return (
    <Box>
      <AppBar
        position="fixed"
        sx={{
          height: "7vh",
          backgroundColor: "#c5e1a5",
        }}
      >
        <Box sx={{ flexGrow: 1, p: 1 }}>
          <Stack
            direction={!!subtitle ? "column" : "row"}
            justifyContent={withBackButton ? "space-between" : "center"}
            alignItems="center"
            height="100%"
          >
            {withBackButton && (
              <IconButton
                sx={{ width: "10%", color: "black", padding: "1%" }}
                disabled={disabled}
              >
                <ArrowBackIosIcon onTouchEnd={() => navigate(-1)} />
              </IconButton>
            )}
            <Typography variant={variant} color="black" component="div">
              {title}
            </Typography>
            {subtitle && (
              <Typography
                variant="body1"
                color="grey"
                component="div"
                marginTop="-3%"
                marginLeft="50%"
              >
                {subtitle}
              </Typography>
            )}
            {withBackButton && <Box sx={{ width: "10%" }}></Box>}
          </Stack>
        </Box>
      </AppBar>
    </Box>
  );
};

export default Header;
